module.exports = __webpack_public_path__ + "img/fr.b23091f6.jpg";